import React from 'react';

import { clickToCall } from '../../helpers/gtm';

type FormErrorCallCenterProps = {
  message: string;
  number: string;
};

export const FormErrorCallCenter = ({ message, number }: FormErrorCallCenterProps) => {
  const numberLink = number ? `tel:${number.replaceAll(' ', '')}` : '';

  return (
    <div data-testid="formerror-callcenter">
      <p data-testid="callcenter-message">
        {message}
        {number && (
          <a
            data-testid="callcenter-phonenumber"
            onClick={() => clickToCall(number)}
            href={numberLink}
          >
            {number}
          </a>
        )}
      </p>
    </div>
  );
};
